var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKirkosMerchantProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 26.01,
    r: 25,
    fill: "white",
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 22.26,
    r: 5.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8438 37.6194C34.8438 32.2778 30.5135 27.9475 25.1719 27.9475C19.8302 27.9475 15.5 32.0903 15.5 37.4319",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKirkosMerchantProfile);
export default __webpack_public_path__ + "static/media/kirkos_merchant_profile.a0e62e35e5aab33d8acbf417955a3a46.svg";
export { ForwardRef as ReactComponent };